import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiFetch } from '../../../lib/api-client';
import { authKeys } from '../auth-keys';

export const useLogout = () => {
  const queryClient = useQueryClient();
  return useMutation<void, Error>({
    mutationFn: async () => {
      try {
        await apiFetch<unknown>('/auth/logout', { method: 'POST' });
      } catch {
        // SEC-2: even if the API fails, drop local state so the user can return to /login
      }
    },
    onSettled: () => {
      queryClient.setQueryData(authKeys.me(), null);
    },
  });
};
